import { LicenseInfo } from '@mui/x-license-pro';

import { environment } from '~/src/utils/environment';

export const setupMui = () => LicenseInfo.setLicenseKey(environment.MUI_LICENSE_KEY);
